export default "__VITE_ASSET__LrYd3J1F__"